import { Feature } from './types';

export const FEATURE_DEPENDENCIES: Partial<Record<Feature, Feature[]>> = {
  INVENTORY_MANAGEMENT: ['STOCK_CONTROL'],
  INTEGRATIONS_CORREO_ARGENTINO: ['PARCEL_SHIPPING'],
};

export function resolveFeatureDependencies(features: Feature[]): Feature[] {
  const dependencies = new Set<Feature>();

  for (const feature of features) {
    const featureDependencies = FEATURE_DEPENDENCIES[feature];

    if (!featureDependencies) {
      continue;
    }
    for (const dependency of featureDependencies) {
      dependencies.add(dependency);
    }
  }

  return [...dependencies];
}
